import React from 'react';
import { Line } from 'react-chartjs-2';

interface LineChartProps {
  options: object;
  data: any;
}

function LineChart(props: LineChartProps) {
  const { data, options } = props;

  return <Line id="chart" data={data} options={options} />;
}

export default LineChart;
